export const states_data = [
  {
    key: '1',
    id: 'ST364285',
    stateName: 'California',
    countryName: 'United States',
    status: 'Active'
  },
  {
    key: '2',
    id: 'ST364284',
    stateName: 'New York',
    countryName: 'United States',
    status: 'Active'
  },
  {
    key: '3',
    id: 'ST364283',
    stateName: 'Texas',
    countryName: 'United States',
    status: 'Active'
  },
  {
    key: '4',
    id: 'ST364282',
    stateName: 'Bavaria',
    countryName: 'Germany',
    status: 'Active'
  },
  {
    key: '5',
    id: 'ST364281',
    stateName: 'Quebec',
    countryName: 'Canada',
    status: 'Active'
  },
  {
    key: '6',
    id: 'ST364280',
    stateName: 'Ontario',
    countryName: 'Canada',
    status: 'Active'
  },
  {
    key: '7',
    id: 'ST364279',
    stateName: 'Florida',
    countryName: 'United States',
    status: 'Active'
  },
  {
    key: '8',
    id: 'ST364278',
    stateName: 'Berlin',
    countryName: 'Germany',
    status: 'Active'
  },
  {
    key: '9',
    id: 'ST364277',
    stateName: 'Victoria',
    countryName: 'Australia',
    status: 'Active'
  },
  {
    key: '10',
    id: 'ST364276',
    stateName: 'Gauteng',
    countryName: 'Egypt',
    status: 'Active'
  }
];
